import ConfirmationBlock, {
	CommonConfirmationBlockProps,
	ConfirmationBlockSkeleton,
	ConfirmationRow,
	ConfirmationRowDescription,
} from "./ConfirmationBlock";
import AccommodationNotesIcon from "../../images/confirmation/accommodation-notes.svg?react";
import i18nPackage from "../../../i18n/i18n";
import { Trans } from "react-i18next";

type AccommodationBlockProps = CommonConfirmationBlockProps & {
	numAccommodated?: number;
};

export function AccommodationBlock({ loading, onEdit, numAccommodated, ...props }: AccommodationBlockProps) {
	if (loading) return <ConfirmationBlockSkeleton />;

	const description =
		numAccommodated === undefined ? undefined : numAccommodated === 0 ? (
			i18nPackage.t("editQuizPage.confirmationBlockTSX.noAccommodations")
		) : (
			<ConfirmationRowDescription>
				<Trans
					i18nKey="editQuizPage.confirmationBlockTSX.numAccommodated"
					values={{ count: numAccommodated }}
					components={{ b: <strong /> }}
					i18n={i18nPackage}
				/>
			</ConfirmationRowDescription>
		);

	return (
		<ConfirmationBlock
			{...props}
			ariaLabel={i18nPackage.t("editQuizPage.confirmationBlockTSX.manageAccommodations")}
			title={i18nPackage.t("editQuizPage.confirmationBlockTSX.accommodation")}
			buttonVariant={"link"}
			onEdit={onEdit}
			buttonText={i18nPackage.t("editQuizPage.confirmationBlockTSX.manageAccommodations")}
			hint={i18nPackage.t("editQuizPage.confirmationBlockTSX.accommodationHint")}
		>
			{description && <ConfirmationRow description={description} />}
		</ConfirmationBlock>
	);
}

type AccommodationStudentBlockProps = {
	name: string;
} & CommonConfirmationBlockProps;

export function AccommodationStudentBlock({ name, ...props }: AccommodationStudentBlockProps) {
	return (
		<ConfirmationBlock
			{...props}
			title={i18nPackage.t("editQuizPage.confirmationBlockTSX.testTaker")}
			variant="compact"
		>
			<ConfirmationRow description={name} descriptionTooltipType="overflow" />
		</ConfirmationBlock>
	);
}

type AccommodationTypeBlockProps = {
	type: "notProctored" | "customProfile";
} & CommonConfirmationBlockProps;

export function AccommodationTypeBlock({ type, ...props }: AccommodationTypeBlockProps) {
	const translationKey = type === "notProctored" ? "notProctored" : "modifiedProctoring";
	return (
		<ConfirmationBlock
			{...props}
			title={i18nPackage.t("editQuizPage.confirmationBlockTSX.accommodation")}
			variant="compact"
		>
			<ConfirmationRow
				description={i18nPackage.t(`editQuizPage.confirmationBlockTSX.${translationKey}`)}
				descriptionTooltipType="wrap"
			/>
		</ConfirmationBlock>
	);
}

type AccommodationNotesBlockProps = {
	notes?: string;
} & CommonConfirmationBlockProps;

export function AccommodationNotesBlock({ notes, ...props }: AccommodationNotesBlockProps) {
	const finalNotes = notes ?? i18nPackage.t("editQuizPage.confirmationBlockTSX.noNotes");
	return (
		<ConfirmationBlock
			{...props}
			title={i18nPackage.t("editQuizPage.confirmationBlockTSX.accommodationNotes")}
			icon={<AccommodationNotesIcon />}
		>
			<ConfirmationRow description={finalNotes} descriptionTooltipType="wrap" />
		</ConfirmationBlock>
	);
}
